/**
 * Is the public storefront open?
 *
 * **It is not, and that is deliberate.** The shop, the landing page, the custom
 * order studio, the cart and the checkout are built and they are switched off.
 * Until the client decides to open the store, the only thing an anonymous
 * visitor may reach is the sign-in page.
 *
 * This is a **switch, not a deletion**. Every storefront route is still in the
 * tree in `routes.tsx` and every page is still in the repository, because the
 * work is done and deleting it would mean building it twice. Turning the store
 * back on is this one line.
 *
 * `false` here means:
 *
 *   - every storefront path redirects to `/auth/sign-in`
 *   - the sign-in page renders with the wordmark alone: no nav, no footer
 *   - signing in goes to `/admin`, because there is nowhere else to go
 *
 * It is NOT access control. A closed storefront hides screens; it does not
 * protect data. `server/api.ts` refuses the data and RLS refuses it again
 * underneath, which is where that guarantee actually lives (NFR-03).
 */
export const STOREFRONT_OPEN = false;

/**
 * Where a person goes when they have signed in.
 *
 * With the store closed there is no account area to land on, so `/account`
 * would bounce straight back to the sign-in form and look like a failed login.
 */
export const AFTER_SIGN_IN = STOREFRONT_OPEN ? '/account' : '/admin';
